import React from 'react';
import Style from './navAppBar.module.css';
import { useTranslation } from 'react-i18next';
import { NavButton } from './navButton.component';
import { navigateToRoute } from '../../navigation/routes';
import { StudyRoleClaimValue } from 'src/services/api/api-client';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { useHasStudyClaims } from 'src/helpers/auth/auth-helper';
import { PatientsDelete } from '../hiddenFeatures/PatientsDelete';

export const StudySettingsNavBar = () => {
  const { t } = useTranslation();
  const study = useStudy();
  const { hasStudyClaim } = useHasStudyClaims();

  if (!study) return <></>;

  return (
    <div className={Style.secondaryNavContainer}>
      <div className={Style.tabsContainer}>
        <NavButton
          title={t('NavMenu.Tabs.RecordsEditor')}
          route={navigateToRoute.formBuilder(study.id)}
          variant={'secondary'}
        />
        <NavButton
          title={t('NavMenu.Tabs.GeneralFormBuilder')}
          route={navigateToRoute.generalFormBuilder(study.id)}
          variant={'secondary'}
        />
        <NavButton
          title={t('NavMenu.Tabs.AvailableForms')}
          route={navigateToRoute.availableForms(study.id)}
          variant={'secondary'}
        />
        <NavButton
          title={t('NavMenu.Tabs.SurveyEditor')}
          route={navigateToRoute.surveyBuilder(study.id)}
          variant={'secondary'}
        />
        {study?.hasDbImport && (
          <NavButton
            title={t('NavMenu.Tabs.Analyzes')}
            route={navigateToRoute.analyzes(study.id)}
            variant={'secondary'}
          />
        )}
        {hasStudyClaim(StudyRoleClaimValue.PatientView) && (
          <NavButton
            title={t('NavMenu.Tabs.PatientPipelines')}
            route={navigateToRoute.patientPipelines(study.id)}
            variant={'secondary'}
          />
        )}
      </div>

      <PatientsDelete />
    </div>
  );
};
